import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './assets/main.css'
import VueLazyLoad from 'vue3-lazyload'
import axios from 'axios'

axios.defaults.baseURL = 'https://u2duoxnw53.execute-api.us-east-1.amazonaws.com/';

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const app = createApp(App)

app.use(router)

app.use(VueLazyLoad)

app.mount('#app')

